import usePlaid from '@/components/plaid/usePlaid';
import { Box, ButtonProps } from '@chakra-ui/react';
import { Button, TrackClickEventProps } from '../common/Button';

const AddAccountButton = ({
    onClickEventParams,
    onClick,
    ...props
}: ButtonProps & {
    onClickEventParams?: TrackClickEventProps['onClickEventParams'];
}) => {
    const { open } = usePlaid();

    return (
        <Button
            colorScheme="dark"
            size="sm"
            h={10}
            px={5}
            onClick={onClick || open}
            onClickEvent="Add Account Button Clicked"
            onClickEventParams={{
                label: 'Add an account',
                ...(onClickEventParams ?? {}),
            }}
            {...props}
        >
            <Box as="span" mr={3}>
                Add an account
            </Box>
            +
        </Button>
    );
};

export default AddAccountButton;
